import type {z} from "zod";

import {EditLeadNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editLeadNoteTitleSchema = requiredStringSchema(
  EditLeadNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editLeadNoteContentSchema = requiredStringSchema(
  EditLeadNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const editLeadNoteFormSchema = EditLeadNoteBody.extend({
  title: editLeadNoteTitleSchema,
  content: editLeadNoteContentSchema,
});
export type EditLeadNoteFormPayload = z.output<typeof editLeadNoteFormSchema>;

export const draftEditLeadNoteFormSchema = editLeadNoteFormSchema.partial();
export type DraftEditLeadNoteFormPayload = z.output<typeof draftEditLeadNoteFormSchema>;
